function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".beratung_shadow_svg__st0{fill:#d9d9d9}");

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  id: "beratung_shadow_svg__Ellipse_26",
  className: "beratung_shadow_svg__st0",
  cx: 149.1,
  cy: 306.6,
  rx: 70,
  ry: 10
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  id: "beratung_shadow_svg__Ellipse_27",
  className: "beratung_shadow_svg__st0",
  cx: 219.1,
  cy: 327.6,
  rx: 70,
  ry: 10
});

function SvgBeratungShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "beratung_shadow_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 382.3 382.3",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzODIuMyAzODIuMyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzgyLjMgMzgyLjM7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRDlEOUQ5O30KCS5zdDF7ZmlsbDojRkZGRkZGO3N0cm9rZTojRDlEOUQ5O3N0cm9rZS13aWR0aDo1O3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDJ7ZmlsbDojRkZGRkZGO3N0cm9rZTojMDA3RUM1O3N0cm9rZS13aWR0aDo1O3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGVsbGlwc2UgaWQ9IkVsbGlwc2VfMjYiIGNsYXNzPSJzdDAiIGN4PSIxNDkuMSIgY3k9IjMwNi42IiByeD0iNzAiIHJ5PSIxMCIvPgo8ZWxsaXBzZSBpZD0iRWxsaXBzZV8yNyIgY2xhc3M9InN0MCIgY3g9IjIxOS4xIiBjeT0iMzI3LjYiIHJ4PSI3MCIgcnk9IjEwIi8+Cjwvc3ZnPgo=";
export { SvgBeratungShadow as ReactComponent };